import React from 'react';
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import * as paths from '@app/constants/paths';
import { PROFESSIONAL } from '@app/constants/userTypes';
import { setUserCredential, setUserProfile, setContinuePath } from '@app/state/actions';
import authentication from '@app/services/authentication';
import database from '@app/services/database';
import config from 'config';

import SignInView from './SignInView';

const actionCodeSettings = {
    url: config.firebaseAuthDeepLink,
    handleCodeInApp: true
};

class ConnectedSignInContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            continuePath: props.location.state && props.location.state.from && props.location.state.from.pathname ? props.location.state.from.pathname : 
                props.continuePath ? props.continuePath : '',
            email: '',
            password: '',
            isPasswordSignIn: false,
            isSignInLinkSent: false,
            isEmailValid: false,
            isPasswordValid: false,
            isLoading: false,
            validationErrors: {
                email: { show: false, errorMessage: '' },
                password: { show: false, errorMessage: '' }
            },
            infoMessage: '',
            errorMessage: ''
        };

        this.validateFields = this.validateFields.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);
        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onClickSignInWithGoogle = this.onClickSignInWithGoogle.bind(this);
        this.onClickSingInWithFacebook = this.onClickSingInWithFacebook.bind(this);
        this.onClickSignInWithTwitter = this.onClickSignInWithTwitter.bind(this);
        this.processSignInWithEmailLink = this.processSignInWithEmailLink.bind(this);
        this.processSocialLogin = this.processSocialLogin.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        if (authentication.isSignInWithEmailLink(window.location.href)) {
            this.processSignInWithEmailLink(window.location.href);
        }
    }

    validateFields() {
        let {
            email,
            isEmailValid,
            password,
            isPasswordValid,
            isPasswordSignIn,
            validationErrors
        } = this.state;
        if (isEmailValid &&
            (!isPasswordSignIn || isPasswordValid)) {
            return true;
        }
        if (!email) {
            const emailRequired = this.props.intl.formatMessage({ id: "email.required" });
            isEmailValid = false;
            validationErrors.email.show = true;
            validationErrors.email.errorMessage = emailRequired;
        }
        if (isPasswordSignIn && !password) {
            const passwordRequired = this.props.intl.formatMessage({ id: "pass.required" });
            isPasswordValid = false;
            validationErrors.password.show = true;
            validationErrors.password.errorMessage = passwordRequired;
        }
        this.setState({
            isEmailValid: isEmailValid,
            isPasswordValid: isPasswordValid,
            validationErrors: validationErrors
        });
        return false;
    }

    onEmailChange(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isValueEmpty = value === '';
        let isEmailValid = !isValueEmpty && value.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i) !== null;;
        if (isEmailValid) {
            validationErrors.email.errorMessage = '';
        }
        else if (isValueEmpty) {
            const emailRequired = this.props.intl.formatMessage({ id: "email.required" });
            validationErrors.email.errorMessage = emailRequired;
        }
        else if (value.length > 3) {
            const emailInvalid = this.props.intl.formatMessage({ id: "email.invalid" });
            validationErrors.email.errorMessage = emailInvalid;
        }
        validationErrors.email.show = !isEmailValid;
        this.setState({
            email: value.trim(),
            isEmailValid: isEmailValid,
            validationErrors: validationErrors,
        });
    }

    onPasswordChange(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isPasswordValid = value.length > 0;
        if (isPasswordValid) {
            validationErrors.password.errorMessage = '';
        }
        else {
            const passwordRequired = this.props.intl.formatMessage({ id: "pass.required" });
            validationErrors.password.errorMessage = passwordRequired;
        }
        validationErrors.password.show = !isPasswordValid;
        this.setState({
            password: value,
            isPasswordValid: isPasswordValid,
            validationErrors: validationErrors,
        });
    }

    onClickSignInWithGoogle(e) {
        this.setState({
            isLoading: true,
            infoMessage: '',
            errorMessage: ''
        });
        authentication.doSignInWithGoogle()
            .then(userCredential => {
                this.processSocialLogin(userCredential);
            })
            .catch(error => {
                let errorMessage = null;
                if (error.code === 'auth/account-exists-with-different-credential') {
                    const accountExistsWithDiffCred = this.props.intl.formatMessage({ id: "account.exists.diff.cred.google" });
                    errorMessage = accountExistsWithDiffCred + error.email;
                }
                else {
                    const loginFailTryAgain = this.props.intl.formatMessage({ id: "login.failed.try.again" });
                    errorMessage = loginFailTryAgain;
                }
                console.log(error);
                this.setState({ isLoading: false, errorMessage: errorMessage });
            });
    }

    onClickSingInWithFacebook(e) {
        this.setState({
            isLoading: true,
            infoMessage: '',
            errorMessage: ''
        });
        authentication.doSignInWithFacebook()
            .then(userCredential => {
                this.processSocialLogin(userCredential);
            })
            .catch(error => {
                let errorMessage = null;
                if (error.code === 'auth/account-exists-with-different-credential') {
                    const accountExistsWithDiffCred = this.props.intl.formatMessage({ id: "account.exists.diff.cred.facebook" });
                    errorMessage = accountExistsWithDiffCred + error.email;
                }
                else {
                    const loginFailTryAgain = this.props.intl.formatMessage({ id: "login.failed.try.again" });
                    errorMessage = loginFailTryAgain;
                }
                console.log(error);
                this.setState({ isLoading: false, errorMessage: errorMessage });
            });
    }

    onClickSignInWithTwitter(e) {
        this.setState({
            isLoading: true,
            infoMessage: '',
            errorMessage: ''
        });
        authentication.doSignInWithTwitter()
            .then(userCredential => {
                this.processSocialLogin(userCredential);
            })
            .catch(error => {
                let errorMessage = null;
                if (error.code === 'auth/account-exists-with-different-credential') {
                    const accountExistsWithDiffCred = this.props.intl.formatMessage({ id: "account.exists.diff.cred.twitter" });
                    errorMessage = accountExistsWithDiffCred + error.email;
                }
                else {
                    const loginFailTryAgain = this.props.intl.formatMessage({ id: "login.failed.try.again" });
                    errorMessage = loginFailTryAgain;
                }
                console.log(error);
                this.setState({ isLoading: false, errorMessage: errorMessage });
            });
    }

    processSignInWithEmailLink(link) {
        let email = window.localStorage.getItem('emailForSignIn');
        if (!email) {
            const provideEmail = this.props.intl.formatMessage({ id: "provide.email.for.confirmation" });
            email = window.prompt(provideEmail);
        }
        this.setState({
            isLoading: true
        });
        authentication.doSignInWithEmailLink(email, link)
            .then(result => {
                window.localStorage.removeItem('emailForSignIn');
                this.processSocialLogin(result);
            })
            .catch(error => {
                let errorMessage = null;
                if (error.code === 'auth/invalid-email') {
                    const invalidEmail = this.props.intl.formatMessage({ id: "email.invalid" });
                    errorMessage = invalidEmail;
                }
                else if (error.code == 'auth/invalid-action-code') {
                    const invalidCode = this.props.intl.formatMessage({ id: "invalid.action.code" });
                    errorMessage = invalidCode;
                }
                else {
                    const signInFailTryAgain = this.props.intl.formatMessage({ id: "login.failed.try.again" });
                    errorMessage = signInFailTryAgain;
                }
                this.setState({ isLoading: false, errorMessage: errorMessage });
                console.log(error)
            });
    }

    processSocialLogin(userCredential) {
        this.props.setUserCredential(userCredential);
        database.findUserById(userCredential.user.uid)
            .then(documentSnapshot => {
                const userProfile = documentSnapshot.data();
                if (userProfile) {
                    this.props.setUserProfile(userProfile);
                    this.setState({ isLoading: false });
                    if (this.state.continuePath) {
                        this.props.setContinuePath(null);
                        this.props.history.push(this.state.continuePath);
                    }
                    else {
                        this.props.history.push(paths.LANDING);
                    }
                }
                else {
                    const userProfile = {
                        userType: PROFESSIONAL,
                        userId: userCredential.user.uid,
                        name: userCredential.user.displayName,
                        telephone: userCredential.user.phoneNumber
                    };
                    database.addUser(userProfile)
                        .then(() => {
                            this.props.setUserProfile(userProfile);
                            this.setState({ isLoading: false });
                            this.props.history.push(paths.ONBOARDING);
                        })
                        .catch(error => {
                            console.log(error);
                            this.setState({
                                isLoading: false,
                                errorMessage: error.message
                            });
                        });
                }
            })
            .catch(error => {
                const errorMessage = 'Unable to retrieve data: ' + error.code + ' ' + error.message;
                this.setState({ isLoading: false, errorMessage: errorMessage });
            });
    }

    onSubmit(e) {
        e.preventDefault();
        if (this.validateFields()) {
            const {
                continuePath,
                email,
                password,
                isPasswordSignIn
            } = this.state;
            this.setState({
                isLoading: true,
                infoMessage: '',
                errorMessage: ''
            });
            if (isPasswordSignIn) {
                authentication.doSignInWithEmailAndPassword(email, password)
                    .then(userCredential => {
                        this.props.setUserCredential(userCredential);
                        database.findUserById(userCredential.user.uid)
                            .then(documentSnapshot => {
                                const userProfile = documentSnapshot.data();
                                if (userProfile) {
                                    this.props.setUserProfile(userProfile);
                                    this.setState({ isLoading: false });
                                    if (continuePath) {
                                        this.props.setContinuePath(null);
                                        this.props.history.push(continuePath);
                                    }
                                    else {
                                        this.props.history.push(paths.LANDING);
                                    }
                                }
                            })
                            .catch(error => {
                                const errorMessage = 'Unable to retrieve data: ' + error.code + ' ' + error.message;
                                this.setState({ isLoading: false, errorMessage: errorMessage });
                            });
                    })
                    .catch(error => {
                        let errorMessage = null;
                        if (error.code === 'auth/wrong-password' ||
                            error.code === 'auth/user-not-found' ||
                            error.code === 'auth/invalid-email') {
                            errorMessage = 'Invalid email or password'
                        }
                        else {
                            errorMessage = 'Unable to sign you in. Please try again.'
                        }
                        this.setState({ isLoading: false, errorMessage: errorMessage });
                    });
            }
            else {
                authentication.doFetchSignInMethod(email)
                    .then(signInMethods => {
                        if (signInMethods.indexOf(authentication.getStaticEmailAuthProvider().EMAIL_PASSWORD_SIGN_IN_METHOD) != -1) {
                            this.setState({
                                isLoading: false,
                                isPasswordSignIn: true
                            });
                        }
                        else if (signInMethods.indexOf(authentication.getStaticEmailAuthProvider().EMAIL_LINK_SIGN_IN_METHOD) != -1) {
                            authentication.doSendSignInLinkToEmail(email, actionCodeSettings)
                                .then(() => {
                                    window.localStorage.setItem('emailForSignIn', email);
                                    const signUpEmailSent = this.props.intl.formatMessage({ id: "sign.up.email.sent" });
                                    this.setState({
                                        isLoading: false,
                                        isSignInLinkSent: true,
                                        infoMessage: signUpEmailSent
                                    });
                                });
                        }
                        else if (signInMethods.indexOf(authentication.getStaticGoogleAuthProvider().GOOGLE_SIGN_IN_METHOD) != -1) {
                            const invalidCredUseGoogle = this.props.intl.formatMessage({ id: "invalid.credentials.use.google" });
                            let errorMessage = invalidCredUseGoogle;
                            this.setState({
                                isLoading: false,
                                errorMessage: errorMessage
                            });
                        }
                        else if (signInMethods.indexOf(authentication.getStaticFacebookAuthProvider().FACEBOOK_SIGN_IN_METHOD) != -1) {
                            const invalidCredUseFacebook = this.props.intl.formatMessage({ id: "invalid.credentials.use.facebook" });
                            let errorMessage = invalidCredUseFacebook;
                            this.setState({
                                isLoading: false,
                                errorMessage: errorMessage
                            });
                        }
                        else if (signInMethods.indexOf(authentication.getStaticTwitterAuthProvider().TWITTER_SIGN_IN_METHOD) != -1) {
                            const invalidCredUseTwitter = this.props.intl.formatMessage({ id: "invalid.credentials.use.twitter" });
                            let errorMessage = invalidCredUseTwitter;
                            this.setState({
                                isLoading: false,
                                errorMessage: errorMessage
                            });
                        }
                        else {
                            const invalidCreds = this.props.intl.formatMessage({ id: "invalid.credentials" });
                            let errorMessage = invalidCreds;
                            this.setState({
                                isLoading: false,
                                errorMessage: errorMessage
                            });
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        let errorMessage = null;
                        if (error.code === 'auth/email-already-in-use') {
                            const emailAlreadyUsed = this.props.intl.formatMessage({ id: "email.already.used" });
                            errorMessage = emailAlreadyUsed
                        }
                        else if (error.code === 'auth/invalid-email') {
                            const emailInvalid = this.props.intl.formatMessage({ id: "email.invalid" });
                            errorMessage = emailInvalid
                        }
                        else {
                            const loginFailTryAgain = this.props.intl.formatMessage({ id: "login.failed.try.again" });
                            errorMessage = loginFailTryAgain;
                        }
                        this.setState({
                            isLoading: false,
                            errorMessage: errorMessage
                        });
                    });
            }
        }
        else {
            window.scrollTo(0, 0);
        }
    }

    generateViewProps() {
        const isSignInDisabled = this.state.isLoading;
        return {
            ...this.state,
            isSignInDisabled: isSignInDisabled,
            onEmailChange: this.onEmailChange,
            onPasswordChange: this.onPasswordChange,
            onSubmit: this.onSubmit,
            onClickSignInWithGoogle: this.onClickSignInWithGoogle,
            onClickSingInWithFacebook: this.onClickSingInWithFacebook,
            onClickSingInWithTwitter: this.onClickSignInWithTwitter
        };
    }

    render() {
        const viewProps = this.generateViewProps();
        return (
            <SignInView {...viewProps} />
        );
    }
}

const mapStateToProps = state => {
    return {
        continuePath: state.continue.continuePath
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setUserCredential: userCredential => dispatch(setUserCredential(userCredential)),
        setUserProfile: userProfile => dispatch(setUserProfile(userProfile)),
        setContinuePath: continuePath => dispatch(setContinuePath(continuePath))
    };
};

const SignInContainer = connect(mapStateToProps, mapDispatchToProps)(injectIntl(ConnectedSignInContainer));
export default SignInContainer;
